'use client';

import { useEffect } from 'react';

import { TLocale } from '@northladder/utilities';

import { IDeviceInfo } from '../../types';

import { useAuthStore } from './useAuthStore';

interface IUseAuthenticationOptions {
  accountId: number;
  deviceInfo?: IDeviceInfo | null;
  locale: TLocale;
  onRedirectToLogin?: () => void;
}

/**
 * -----------------------------------------------------------------------------
 * This provides logic to retrieve auth info from the persisted storage and
 * configures it at app startup.
 *
 * - NOTE: Manages the local state with `authStore` -> `zustand` store.
 */
export const useAuthentication = ({
  accountId,
  deviceInfo,
  locale,
  onRedirectToLogin,
}: IUseAuthenticationOptions) => {
  const { activeSession, updateActivityLog } = useAuthStore();

  // TODO 1: Add support for redirecting to the previous recent route after login
  // TODO 2: Also have functionality to redirect at middleware level via a custom hook
  // NOTE: We should provide an option of keep the most recent redirect route
  // in memory to allow for future seamless redirection
  useEffect(() => {
    if (!activeSession) {
      onRedirectToLogin?.();
      return;
    }

    // TODO: P0:: This is likely to cause bugs since the accountId differing from
    // the active session accountId should force a switch of the active session
    // not just the activity log.
    if (accountId !== activeSession?.index) {
      updateActivityLog({
        locale,
        deviceInfo,
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeSession]);
};
